module.exports = __webpack_public_path__ + "static/media/error_image.2641f3d5.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./img/svg/error_image.svg
 ** module id = 293
 ** module chunks = 0
 **/